import React, { useEffect, useState } from 'react'
import Loading from '../components/Loading'
import { useParams, Link } from 'react-router-dom'
const url = 'https://www.thecocktaildb.com/api/json/v1/1/lookup.php?i='

const SingleCocktail = () => {
  const {id}=useParams();
  const[loading,setLoading]=useState(false)
  const[cocktail,setCocktail]=useState(null)

  const getCocktail=async()=>{
    try {
      const response=await fetch(`${url}${id}`)
      const data=await response.json()
      //console.log(data);
      if(data.drinks){
        const{
          strDrink:name,
          strDrinkThumb:Image,
          strGlass:glass,
          strAlcoholic:info,
          strCategory:category,
          strInstructions:instruction,
          strIngredient1,
          strIngredient2,
          strIngredient3,
          strIngredient4,
          strIngredient5,
  
        }=data.drinks[0]
        const ingredients=
        [strIngredient1,
          strIngredient2,
          strIngredient3,
          strIngredient4,
          strIngredient5,]
          const newCocktail= {name,Image,glass,info,category,instruction,ingredients}
          setCocktail(newCocktail)
      }
      else{
        setCocktail(null)
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false)
  }
  

useEffect(()=>{
setLoading(true);
getCocktail()

},[id])


  if(loading){
    return <Loading />
  }
 if(!cocktail){
  return (
    <section className='section cocktail-section'>
  <h1>NO cocktail</h1>
  </section>
  )
 } else{

 const {name,Image,glass,info,category,instruction,ingredients}=cocktail

  return (
  <section className='section cocktail-section'>
  <Link to="/" className='btn btn-primary '>Back Home</Link>
    <h2 className='section-title'>{name}</h2>
    <div className='drink'>
      <img src={Image} alt={name}/>
      <div className='drink-info'>
      <p>
        <span className='drink-data'>name:</span>{name}
      </p>
      <p>
        <span className='drink-data'>category:</span>{category}
      </p>
      <p>
        <span className='drink-data'>info:</span>{info}
      </p>
      <p>
        <span className='drink-data'>glass:</span>{glass}
      </p>
      <p>
        <span className='drink-data'>instruction:</span>{instruction}
      </p>
      <p>
      <span className='drink-data'>ingredients :</span>
              {ingredients.map((item, index) => {
                return item ? <span key={index}> {item}</span> : null
              })}
      </p>
    </div>
    </div>
  </section>
  )

      }
  }


export default SingleCocktail
